import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useThemeUI } from 'theme-ui';
import { Col, Container, Row, EVEntry } from '@uswitch/ev-core/react';
import { path } from '@uswitch/ev-utils/obj';
/* eslint-disable no-magic-numbers */

import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";
export default (function (_ref) {
  var _ref$entries = _ref.entries,
      entries = _ref$entries === void 0 ? [] : _ref$entries,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? {} : _ref$options;

  var _useThemeUI = useThemeUI(),
      theme = _useThemeUI.theme;

  var styles = (options === null || options === void 0 ? void 0 : options.styles) || {};
  var rowStyles = (styles === null || styles === void 0 ? void 0 : styles.row) || {};
  var colStyles = (styles === null || styles === void 0 ? void 0 : styles.col) || {};

  var _path = path(['modules', 'collection', 'variants', 'sidebar'], theme, {}),
      _path$content = _path.content,
      contentStyles = _path$content === void 0 ? {} : _path$content,
      _path$sidebar = _path.sidebar,
      sidebarStyles = _path$sidebar === void 0 ? {} : _path$sidebar,
      _path$container = _path.container,
      containerStyles = _path$container === void 0 ? {} : _path$container;

  return _jsx(Container, {
    sx: _objectSpread({}, styles),
    children: _jsxs(Row, {
      direction: "row",
      cols: [6, 12, 12],
      sx: _objectSpread(_objectSpread({}, rowStyles), containerStyles),
      children: [_jsx(Col, {
        span: contentStyles.span || [6, 12, 8],
        sx: _objectSpread(_objectSpread({}, colStyles), contentStyles),
        children: _jsx(EVEntry, _objectSpread({}, entries[0]))
      }), _jsx(Col, {
        span: sidebarStyles.span || [6, 12, 4],
        sx: _objectSpread(_objectSpread({}, colStyles), sidebarStyles),
        children: _jsx(EVEntry, _objectSpread({}, entries[1]))
      })]
    })
  });
});
//# sourceMappingURL=collection-sidebar.js.map